import React from 'react';
import { IconChevronsRight } from '@tabler/icons-react';
import { NavLink, Outlet } from 'react-router';

function SuperAdminDashboard() {
  return (
    <div className="super-admin">
      <div className="fixed-container-left">
        <div className="d-flex ">
          <div className="coverage-container">
            <h4>Super Admin Panel</h4>
            <div className="d-flex gap-2 flex-column">
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/organizations"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Organizations
                <IconChevronsRight size={24} />
              </NavLink>
            </div>
            <div className="d-flex gap-2 flex-column">
              <hr />
              <h4 className="text-muted">Analytics</h4>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/user-activity"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                User Activity
                <IconChevronsRight size={24} />
              </NavLink>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/session-engagement"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Sessions Engagement
                <IconChevronsRight size={24} />
              </NavLink>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/new-coverage-verification"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Coverage Verification Search
                <IconChevronsRight size={24} />
              </NavLink>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/drug-search-usage"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Drug Search
                <IconChevronsRight size={24} />
              </NavLink>
              <hr />
              <h4 className="text-muted">Investor Metrics</h4>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/retention-growth"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Retention & Growth
                <IconChevronsRight size={24} />
              </NavLink>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/practice-performance"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Practice Performance
                <IconChevronsRight size={24} />
              </NavLink>
              <NavLink
                style={{ textDecoration: 'none' }}
                to="/super-admin/analytics/workflow-adoption"
                className={({ isActive }) =>
                  `user-type ${isActive ? 'active' : ''}`
                }
              >
                Workflow Adoption
                <IconChevronsRight size={24} />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="super-admin-drug-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default SuperAdminDashboard;
